var _desc, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoOrdenarAsc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 7.13 7.3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(50,50,50)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-7.29, -7.39)",
    d: "M 6.41786 1.45936 L 6.41787 11.2149 L 2.15581 6.95287 C 1.81519 6.61226 1.25623 6.61226 0.915617 6.95287 C 0.575002 7.29349 0.575002 7.84371 0.915617 8.18433 L 6.67114 13.9399 C 7.01176 14.2805 7.56198 14.2805 7.9026 13.9399 L 13.6581 8.18433 C 13.9987 7.84371 13.9987 7.29349 13.6581 6.95287 C 13.3175 6.61226 12.7673 6.61226 12.4267 6.95287 L 8.16461 11.2149 L 8.16461 1.45936 C 8.16461 0.979002 7.77159 0.585984 7.29124 0.585984 C 6.81088 0.585984 6.41786 0.979002 6.41786 1.45936 Z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoOrdenarAsc);
export default __webpack_public_path__ + "static/media/icono-ordenar-asc.ce6efd34e2c1138935b21a3ae6d2cf8b.svg";
export { ForwardRef as ReactComponent };